
<div>
	<v-dialog v-model="dialog" max-width="800px" scrollable :fullscreen="$vuetify.breakpoint.smAndDown">
		<v-card>
			<v-img :src="wallet.image" gradient="to bottom right, rgba(100,115,201,.50), rgba(25,32,72,.50)">
				<v-card-title class="white--text font-weight-bold mb-3">
					<v-spacer />
					<v-btn v-if="this.wallet.type === this.companyType" rounded color="white" class="indigo-text font-weight-bold mr-2" @click="redeemCredits">
						Redeem Credits
					</v-btn>
					<v-btn icon dark @click="dialog = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-subtitle class="pb-0 white--text font-weight-bold text-h6">R{{ wallet.total }} - {{ wallet.label }}</v-card-subtitle>
				<v-card-text
					id="transaction-dialog-content"
					class="pa-2 pr-1"
					:style="{ 'max-height': $vuetify.breakpoint.smAndDown ? '600px' : '200px', 'overflow-y': 'auto' }"
				>
					<v-container>
						<v-row justify="space-between" class="text-subtitle-1 font-weight-bold white--text">
							<v-col>
								<div>
									Date<v-icon color="grey lighten-2" dark @click="toggleOrder">{{ sortOrderDesc ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
								</div>
							</v-col>
							<v-col>
								<div>Amount</div>
							</v-col>
							<v-col class="hidden-sm-and-down">
								<div>Invoice</div>
							</v-col>
							<v-col class="text-end">
								<div>Balance</div>
							</v-col>
						</v-row>
						<v-row v-for="({ date, amount, balance, reference, referenceLink, typeColor, typeSymbol }, i) in transactions" :key="i" class="text-body-2 white--text">
							<v-col class="font-weight-medium">
								<div>{{ date }}</div>
							</v-col>
							<v-col>
								<v-chip class="d-flex text-center justify-center white--text" style="width: 70px" small :color="typeColor" @click="viewInvoice(referenceLink)">
									<v-icon left x-small>
										{{ typeSymbol }}
									</v-icon>
									{{ amount }}
								</v-chip>
							</v-col>
							<v-col class="font-weight-medium hidden-sm-and-down">
								<div v-if="!reference">-</div>
								<a
									v-else-if="referenceLink"
									:href="referenceLink || 'javascript:void(0)'"
									target="_blank"
									class="text-caption font-weight-thin font-italic grey--text text--lighten-2 wallet-reference-label"
									>{{ reference }}</a
								>
								<span v-else class="text-caption font-weight-thin font-italic grey--text text--lighten-2 wallet-reference-label">{{ reference }}</span>
							</v-col>
							<v-col class="text-end text-body-1 font-weight-bold pr-0">
								<div>
									R{{ balance }}
									<v-menu bottom left>
										<template #activator="{ on }">
											<v-btn small dark icon v-on="on">
												<v-icon small>mdi-dots-vertical</v-icon>
											</v-btn>
										</template>

										<v-list class="px-2" :disabled="!referenceLink">
											<v-list-tile v-if="reference" link @click="viewInvoice(referenceLink)">
												<v-list-tile-title v-if="referenceLink">{{ reference }}</v-list-tile-title>
												<v-list-tile-title v-else>{{ reference }}<span class="caption"> - (No Link)</span></v-list-tile-title>
											</v-list-tile>
											<v-list-tile v-else link>
												<v-list-tile-title>No Invoice</v-list-tile-title>
											</v-list-tile>
										</v-list>
									</v-menu>
								</div>
							</v-col>
						</v-row>
					</v-container>
				</v-card-text>
			</v-img>
		</v-card>
	</v-dialog>
	<v-dialog v-model="redeemed" persistent max-width="400px" :fullscreen="$vuetify.breakpoint.smAndDown">
		<v-card class="justify-center text-center card-rounded pb-5">
			<v-card-title
				class="pa-2 white--text justify-center text-center secondary"
				style="font-family: Montserrat; font-style: normal; font-weight: bold; font-size: 12px; line-height: 7px; text-align: center"
			>
				<v-row>
					<v-spacer></v-spacer>
					<span class="headline white--text">Credits Redeemed!</span>
					<v-spacer></v-spacer>
				</v-row>
				<v-btn icon color="white" @click="redeemed = false">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>

			<v-card-text class="text-center justify-center">
				<v-container class="card-rounded pb-2 text-center justify-center">
					<v-row :class="$vuetify.breakpoint.width >= 1264 ? 'pr-8 pl-7' : ''">
						<v-col fontcolor="black">Thank you, we have received your request.</v-col>
					</v-row>
				</v-container>
			</v-card-text>
		</v-card>
	</v-dialog>
</div>
